const state = {
  navItems: [
    { name: "ladies", hasSubNav: false },
    { name: "gents", hasSubNav: false },
    { name: "brands", hasSubNav: false },
    { name: "stores", hasSubNav: false },
    { name: "sights & sounds", hasSubNav: false }
  ],
  currentNavItem: null,
  currentSubNavItem: null
};

const getters = {
  getNavItems: () => state.navItems,
  getNavItemsMobile: () => {
    const arr = [...state.navItems];
    /*Index needs to be the amount of nav items*/
    const temp = state.navItems[4];
    arr.splice(4, 1);
    arr.splice(3, 0, temp);
    return arr;
  },
  getCurrentNavItem: () => state.currentNavItem,
  getCurrentSubNavItem: () => state.currentSubNavItem
};

const actions = {};
``;
const mutations = {
  setCurrentNavItem(state, payload) {
    state.currentNavItem = payload;
  },
  setCurrentSubNavItem(state, payload) {
    state.currentSubNavItem = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
